import { createStore } from "owa-satcheljs";

const defaultExport: () => {
    IsImmutableIdFeatureOnForConnectedAccount: boolean;
} = createStore("immutableId", {
    IsImmutableIdFeatureOnForConnectedAccount: false,
});
export default defaultExport;
